import React, { memo, useCallback, useRef, useState } from "react";
import styled from "styled-components";

const StyledFileInput = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${({ theme }) => theme.fontSize.lsmall};
  ${({ containerCss }) => containerCss};
  .input {
    display: none;
  }
  .button {
    background-color: ${({ theme }) => theme.blue};
    cursor: pointer;
    padding: 6px 9px;
    color: white;
    border-radius: 3px;

    outline: 0;
    border: 0;
    margin-right: 15px;
  }
  .mini_button {
    cursor: pointer;
    color: ${({ theme }) => theme.blue};
  }
  .text {
    color: ${({ theme }) => theme.black};
  }
  .placeholder {
    color: ${({ theme }) => theme.weakGray};
  }
`;

const FileInput = ({
  onChange,
  v = [],
  setV,
  buttonText = "选择文件",
  placeholder = "选择文件或拖至此处",
  mini = false,
  containerCss,
}) => {
  const fileInputRef = useRef(null);

  const handleButtonClick = useCallback(() => {
    const input = fileInputRef.current;
    if (!input) return;
    input.click();
  }, []);

  const handleFile = useCallback(
    (e) => {

      if (onChange && onChange(e) == "invalid file") return;
      const files = e.currentTarget.files;
      if (files && files.length > 0) {
        const fileNames = Array.from(files).map((file) => file.name)
        setV && setV(fileNames)
      }
    },
    [onChange, setV]
  );

  const showName = v.length > 1 ? v.join('，') : v;

  return (
    <StyledFileInput containerCss={containerCss}>
      <input
        className="input"
        type="file"
        ref={fileInputRef}
        onChange={handleFile}
        accept= {mini ? ".json" : ".zip"} 
      />
      {!mini && (
        <button className="button" onClick={handleButtonClick}>
          {buttonText}
        </button>
      )}
      {v && !mini ? (
        <span className="text" title={showName}>{showName}</span>
        )
       : (
        <span className="placeholder">{placeholder}</span>
      )}
      {mini && (
        <span className="mini_button" onClick={handleButtonClick}>
          {buttonText}
        </span>
      )}
    </StyledFileInput>
  );
};

export default memo(FileInput);
